import type { GuardedFeature } from "adl-gen/ferovinum/app/db";
import { useSelectedOrgFeatures } from "./selected-entity-context";

/**
 * Simple hook to determine if a feature is enabled for the selected organisation.
 */
export const useIsFeatureEnabled = (feature: GuardedFeature) => {
  const features = useSelectedOrgFeatures();
  return features.includes(feature);
};
